module.exports = __webpack_public_path__ + "media/buy_report_icons/rzs-7155d74b.svg";